export default __webpack_public_path__ + "static/media/login_img.17df2ac6.svg";